var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 6H7l1 4zm-1 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.715 2.858c-.777-1.294-2.653-1.294-3.43 0L.817 11.971C.017 13.304.977 15 2.532 15h10.936c1.554 0 2.514-1.696 1.715-3.03zm4.61 9.627L8.858 3.373a1 1 0 0 0-1.715 0l-5.468 9.112A1 1 0 0 0 2.532 14h10.936a1 1 0 0 0 .857-1.515",
  clipRule: "evenodd"
})));
export default SvgWarning;